/**
 * Supplier Portal roles
 */
const ROLES = {
  ADMIN: 'ADMIN',
  OWNER: 'OWNER',
  STANDARD: 'STANDARD'
}

/**
 * Mutation types of the store
 */
const mutationTypes = {
  CLEAR_SELECTION: 'CLEAR_SELECTION',
  SET_SUPPLIER: 'SET_SUPPLIER'
}

/**
 * Initial state
 */
const state = {
  selectedSupplierId: undefined,
  userRolesForSupplier: []
}

/**
 * Getters
 */
const getters = {
  isAdminUser(state) {
    return state.userRolesForSupplier.includes(ROLES.ADMIN)
  },

  isOwnerUser(state) {
    return state.userRolesForSupplier.includes(ROLES.OWNER)
  },

  isStandardUser(state) {
    return state.userRolesForSupplier.includes(ROLES.STANDARD)
  },

  supplierSelected(state) {
    return !!state.selectedSupplierId
  }
}

/**
 * Actions
 */
const actions = {
  clearSelection({ commit }) {
    commit(mutationTypes.CLEAR_SELECTION)
  },

  setSelectedSupplier({ commit, dispatch }, supplierId) {
    if (supplierId)
      dispatch('profile/fetchSupplierProfile', supplierId, { root: true })

    // Find user Roles from auth store for selected Supplier
    const userRoles = this.state.auth.accounts.find(
      (account) => account.supplierId === supplierId
    )?.roles

    commit(mutationTypes.SET_SUPPLIER, { supplierId, userRoles })
  }
}

/**
 * Mutations
 */
const mutations = {
  [mutationTypes.CLEAR_SELECTION](state) {
    state.selectedSupplierId = undefined
    state.userRolesForSupplier = []
  },

  [mutationTypes.SET_SUPPLIER](state, { supplierId, userRoles }) {
    state.selectedSupplierId = supplierId
    state.userRolesForSupplier = userRoles
  }
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
}
